import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ExcelTable } from '../models/form/excel-table.model';
import { WorkReportUploadResponse } from '../models/form/work-report-upload-response.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';
import { Observable } from 'rxjs';
import { ListEnumValuesRequest } from '../models/form/list-enum-values-request.model';
import { InitWorkReportRequest } from '../models/form/init-work-report-request.model';
import { SignUrlInfo } from '../models/form/sign-url-info.model';
import { WorkFlowRefectSignRequest } from '../models/form/work-flow-refect-sign-request.model';
import { WorkReportDocType } from '../models/form/work-report-doc-type.enum';
import { WorkReport } from '../models/form/work-report.model';
import { FormFlowInfo } from '../models/form/form-flow-info.model';
import { EditableWorkReportRequest } from '../models/form/editable-work-report-request.model';
import { EditableWorkReportResponse } from '../models/form/editable-work-report-response.model';
import { WorkReportMeasuredValueInfo } from '../models/form/work-report-measured-value-info.model';
import { ParseJsFormRequest } from '../models/form/parse-js-form-request.model';
import { FormItemMeasuredProjectInfo } from '../models/form/form-item-measured-project-info.model';
import { CopyRequest } from '../models/form/copy-request.model';
import { DownloadFileByIdsRequest } from '../models/form/download-file-by-ids-request.model';
import { WorkReportAggregateSearchRequest } from '../models/form/work-report-aggregate-search-request.model';
import { WorkReportMatchDesignValueRequest } from '../models/form/work-report-match-design-value-request.model';
import { WorkReportMatchDesignValueResponse } from '../models/form/work-report-match-design-value-response.model';
import { WorkReportStatRequest } from '../models/material/work-report-stat-request.model';

@Injectable({
  providedIn: 'root',
})
export class WorkReportService extends RequestService<WorkReport> {
  static PATH = '/work/report';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(httpClient, WorkReportService.PATH, globalService.debugUrl);
  }

  getWorkFlowKeyById(workOrderId: number) {
    return this.httpClient.get<string>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/getWorkFlowKeyById/${workOrderId}`,
    );
  }

  rejectSign(params: WorkFlowRefectSignRequest) {
    return this.httpClient.post<boolean>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/rejectSign`,
      params,
    );
  }

  init(params: InitWorkReportRequest): Observable<WorkReport> {
    return this.httpClient.post<ExcelTable>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/init`,
      params,
    );
  }

  reply(workOrderId: number) {
    return this.httpClient.get<number>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/fileReply/submitByReceiveId/${workOrderId}`,
    );
  }

  getSignUrl(workOrderId: number) {
    return this.httpClient.get<SignUrlInfo>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/getSignUrlInfo/${workOrderId}`,
    );
  }

  findByMenuFormId(formId: string) {
    return this.httpClient.get<ExcelTable>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/byMenuFormId/${formId}`,
    );
  }

  submit(workOrder: WorkReport) {
    return this.httpClient.post<number>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/submit`,
      workOrder,
    );
  }

  matchHistoryFormFlows(workOrder: WorkReport) {
    return this.httpClient.post<Array<FormFlowInfo>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/matchHistoryFormFlows`,
      workOrder,
    );
  }

  uploadFileWithoutProgress(file: File, docType: WorkReportDocType) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('docType', docType.toString());
    formData.append('convertToPdf', 'true');
    return this.httpClient.post<WorkReportUploadResponse>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/upload`,
      formData,
    );
  }

  listSame(workReport: WorkReport) {
    return this.httpClient.post<WorkReport[]>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/listSame`,
      workReport,
    );
  }

  copy(req: CopyRequest) {
    return this.httpClient.post<Array<ExcelTable>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/copy`,
      req,
    );
  }

  downloadFileByIds(req: DownloadFileByIdsRequest) {
    return fetch(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/downloadFileByIds`,
      {
        method: 'POST',
        body: JSON.stringify(req),
        headers: {
          token: this.globalService.token,
        },
      },
    );
    // return this.httpClient.post(
    //   `${
    //     this.globalService.debugUrl
    //       ? this.globalService.debugUrl
    //       : environment.host
    //   }${WorkReportService.PATH}/downloadFileByIds`,
    //   req,
    //   { responseType: 'arraybuffer', observe: 'events' }
    // );
  }

  downloadInspectionReport(req: WorkReportStatRequest) {
    return fetch(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/downloadInspectionReport`,
      {
        method: 'POST',
        body: JSON.stringify(req),
        headers: {
          token: this.globalService.token,
        },
      },
    );
  }

  downloadMenuReport(req: WorkReportStatRequest) {
    return fetch(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/downloadMenuReport`,
      {
        method: 'POST',
        body: JSON.stringify(req),
        headers: {
          token: this.globalService.token,
        },
      },
    );
  }

  aggregateSearch(req: WorkReportAggregateSearchRequest) {
    return this.httpClient.post<WorkReport[]>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/aggregateSearch`,
      req,
    );
  }

  copyById(id: number) {
    return this.httpClient.get<WorkReport>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/copyById/${id}`,
    );
  }

  addingContent(workOrder: WorkReport) {
    return this.httpClient.post<boolean>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/addingContent`,
      workOrder,
    );
  }

  listEnumValues(req: ListEnumValuesRequest) {
    return this.httpClient.post<string[]>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/listEnumValues`,
      req,
    );
  }

  removeByAdmin(id: number) {
    return this.httpClient.get<number>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/removeByAdmin/${id}`,
    );
  }

  editable(req: EditableWorkReportRequest) {
    return this.httpClient.post<EditableWorkReportResponse>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/editable`,
      req,
    );
  }

  measuredValue(workReportId: string) {
    return this.httpClient.get<WorkReportMeasuredValueInfo[]>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/measuredValue/${workReportId}`,
    );
  }

  parseJsForm(req: ParseJsFormRequest) {
    return this.httpClient.post<FormItemMeasuredProjectInfo>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/parseJsForm`,
      req,
    );
  }

  matchDesignValue(req: WorkReportMatchDesignValueRequest) {
    return this.httpClient.post<WorkReportMatchDesignValueResponse>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/matchDesignValue`,
      req,
    );
  }

  updateSignDateEditTypeById(req: WorkReport) {
    return this.httpClient.post<WorkReport>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkReportService.PATH}/updateSignDateEditTypeById`,
      req,
    );
  }
}
